import React from 'react';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { useTranslation } from 'hooks/useTranslation';

import { authPaths } from 'features/auth/routes/paths';

import { useStyles } from './styles';

export const ReturnToLoginLink = () => {
  const classes = useStyles();
  const { t } = useTranslation('auth');

  return (
    <Grid className={classes.loginContainer}>
      <Typography className={classes.loginPassword}>
        {t('returnTo')}{' '}
        <Link className={classes.link} to={authPaths.static.login}>
          {t('logIn')}
        </Link>
      </Typography>
    </Grid>
  );
};